import { lazyImport } from "@src/utility/lazyImport";

const { Location } = lazyImport(
  () => import("../../features/location"),
  "Location"
);
const LocationRoutes = [
  {
    path: "/location",
    element: <Location />,
    meta: {
      action: "read",
      resource: "location",
    },
  },
];

export default LocationRoutes;
